module.exports = __webpack_public_path__ + "static/fj09adf-77fd0395a95184223f8259af371bef42.png";